(function ($) {

// ==============================================================
// text us links open olark
// ==============================================================
    $(document).ready(function () {

        $('.section_collapse_phases .section-title-wrap .expand span').click(function () {
            console.log('Collapse test');
            if ($(this).hasClass('collapsed')) {
                $('.section_collapse_phases .phases-list .card .show').collapse('show');
                $(this).removeClass('collapsed');
                $(this).text('COLLAPSE ALL');
            } else {
                $('.section_collapse_phases .phases-list .card .show').collapse('hide');
                $(this).addClass('collapsed');
                $(this).text('EXPAND ALL');
            }
        });
    });






})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/collapse_phases.es6